import Mask from '__components/Mask';
import { EmTouchableOpacity } from 'emrn-design/EmTouchable';
import { LinearGradient } from 'emrn-design/LinearGradient';
import { Spacer } from 'emrn-design/Spacer';
import { rpx } from 'emrn-design/rpx';
import React, { Component } from 'react';
import { StyleSheet, View, Text, Image } from 'react-native';

interface Props {
  onPress?: Function;
  money?: number;
}

interface State {
  isShow: boolean;
}

export class IsDrawCashPop extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isShow: false,
    };
  }

  show = () => {
    this.setState({ isShow: true });
  };

  hide = () => {
    this.setState({ isShow: false });
  };

  render() {
    const { onPress, money } = this.props;
    const { isShow } = this.state;
    return (
      <>
        {isShow ? (
          <Mask>
            <View style={styles.content}>
              <LinearGradient
                start={{ x: 0, y: 0 }}
                end={{ x: 0, y: 0.19 }}
                colors={['#FFF7C2', '#FFFFFF']}
                style={styles.main}
              >
                <Spacer size={rpx(36)} />
                <View>
                  <Text style={styles.text1}>
                    当前可提现<Text style={styles.text2}>{money + '元'}，</Text>
                    是否提现？
                  </Text>
                </View>
                <Spacer size={rpx(30)} />
                <View style={styles.btnGroup}>
                  <EmTouchableOpacity
                    onPress={() => {
                      this.hide();
                    }}
                  >
                    <Image
                      style={styles.cancel}
                      resizeMode={'stretch'}
                      source={require('../../images/invite/cancel.png')}
                    />
                  </EmTouchableOpacity>
                  <EmTouchableOpacity
                    onPress={() => {
                      onPress && onPress();
                    }}
                  >
                    <Image
                      style={styles.confirm}
                      source={require('../../images/invite/withDraw.png')}
                      resizeMode="stretch"
                    />
                  </EmTouchableOpacity>
                </View>
                <Spacer size={rpx(30)} />
              </LinearGradient>
            </View>
          </Mask>
        ) : null}
      </>
    );
  }
}

const styles = StyleSheet.create({
  content: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  btnGroup: {
    width: rpx(265),
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  main: {
    width: rpx(300),
    backgroundColor: '#fff',
    borderRadius: rpx(32),
    alignItems: 'center',
  },
  text1: {
    fontSize: rpx(15),
    color: '#333333',
  },
  text2: {
    fontSize: rpx(15),
    color: '#FF2233',
  },
  text5: {
    fontSize: rpx(17),
    color: '#FFFFFF',
  },
  text6: {
    fontSize: rpx(17),
    color: '#5F6DFF',
  },
  money_bgImg: {
    width: rpx(192.5),
    height: rpx(80),
    alignItems: 'center',
    justifyContent: 'center',
  },
  cancel: {
    width: rpx(132),
    height: rpx(41),
  },
  confirm: {
    width: rpx(132),
    height: rpx(41),
  },
});
